import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionsGuard } from '@core/guard/permissions.guard';
import { PagesGenerateSelectionModule } from './pages-generate-selection-core/pages-generate-selection.module';
import { PagesReportCoreModule } from './pages-report-core/pages-report-core.module';
import { PagesViewConfigCoreModule } from './pages-view-config-core/pages-view-config-core.module';
import { PagesConfigPresorteoCoreModule } from './pages-config-presorteo-core/pages-config-presorteo-core.module';
import { AuthGuard } from 'src/app/security/guards/auth.guard';
import { WelcomeComponent } from '../../page-home/welcome/welcome.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        canActivate: [AuthGuard],
        component: WelcomeComponent
    },
    {
        path: 'generate-selection',
        canActivate: [PermissionsGuard],
        data: { permissions: ['core.generate-selection.get'] },
        loadChildren: () => PagesGenerateSelectionModule,
    },
    {
        path: 'view-config',
        canActivate: [PermissionsGuard],
        data: { permissions: ['core.view-config.get'] },
        loadChildren: () => PagesViewConfigCoreModule,
    },
    {
        path: 'config-presorteo',
        canActivate: [PermissionsGuard],
        data: { permissions: ['core.config.presorteo'] },
        loadChildren: () => PagesConfigPresorteoCoreModule,
    },
    {
        path: 'report-onj',
        canActivate: [PermissionsGuard],
        data: { permissions: ['core.report-gna.get'] },
        loadChildren: () => PagesReportCoreModule,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesCoreRoutingModule { }
